import React, { useState, useEffect, useRef, useMemo } from 'react';
import 'react-multi-carousel/lib/styles.css';
import { Col, Form } from 'react-bootstrap';
import { getSubject, getDepartment, getCreateContactUs } from '../../utils/api';
import Loader from '../loader/loader'
import { Toast } from 'primereact/toast';
import Select, { components } from 'react-select';
import useToastNotification from '../../hooks/useToastNotification';
import ArrowDown from '../../assets/icons/arrow-down.svg'
import { Sidebar } from 'primereact/sidebar';
import { isMobile } from 'react-device-detect';

const ContactUs = () => {
    const toast = useRef(null);
    const [subject, setSubject] = useState([]);
    const [department, setDepartment] = useState([]);
    const [subjectId, setSubjectId] = useState(null);
    const [departmentId, setDepartmentId] = useState(null);
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [visibleSubject, setVisibleSubject] = useState(false);
    const [visibleDepartman, setVisibleDepartman] = useState(false);
    const [fullName, setFullName] = useState('');
    const [mobile, setMobile] = useState('');
    const [message, setMessage] = useState();
    const [isDepartmentInvalid, setIsDepartmentInvalid] = useState(false);
    const [isSubjectInvalid, setIsSubjectInvalid] = useState(false);

    const { showError, showSuccess } = useToastNotification();


    // //set error and success message
    // const showError = (error) => {
    //     toast.current.show({ severity: 'error', detail: error.text, life: 6000 });
    // }
    // const showSuccess = (success) => {
    //     toast.current.show({ severity: 'success', detail: success.text, life: 6000 });
    // }
    // Fetch department
    useEffect(() => {
        const fetchDepartment = async () => {
            try {
                const pay = { pageSize: 1000, pageIndex: 0 };
                const res = await getDepartment(pay);
                const items = res.data.data.items;
                setDepartment(items);
            } catch (error) {
                console.error('Error fetching departments:', error);
            }
        };
        fetchDepartment();
    }, []);

    // Fetch subject
    useEffect(() => {
        const fetchSubject = async () => {
            try {
                const pay = { pageSize: 1000, pageIndex: 0 };
                const res = await getSubject(pay);
                const items = res.data.data.items;
                setSubject(items);
            } catch (error) {
                console.error('Error fetching subjects:', error);
            }
        };
        fetchSubject();
    }, []);

    const cleareData = () => {
        setValidated(false);
        setDepartmentId(null)
        setFullName('')
        setMessage('')
        setSubjectId(null)
        setMobile('')
    }
    const createContact = async (e) => {
        e.preventDefault();
        console.log('.....',subjectId)
        if (!departmentId) {
            setIsDepartmentInvalid(true);
        } else {
            setIsDepartmentInvalid(false);
            // ارسال فرم
        }
        if (!subjectId) {
            setIsSubjectInvalid(true);
        } else {
            setIsSubjectInvalid(false);
            // ارسال فرم
        }
        const form = e.currentTarget;
        if (form.checkValidity() === true) {
            setLoading(true)
            
            try {
                let pay = {
                    fullName: fullName,
                    phoneNumber: mobile,
                    message: message,
                    subjectId: typeof subjectId === 'object' && Object.keys(subjectId).length > 0 ? subjectId.id : subjectId,
                    departmentId: typeof departmentId === 'object' && Object.keys(departmentId).length > 0 ? departmentId.id : departmentId
                }
                let res = await getCreateContactUs(pay)
                if (res.data.isSuccess) {
                    console.log(res.data.message)
                    let message = {
                        text: res.data.message
                    }
                    showSuccess(message)
                    //   cleareData()
                    setLoading(false)

                } else {
                    setLoading(false)
                    let message = {
                        text: res.data.message
                    }
                    showSuccess(message)
                    // window.location.href = `/sign-up?mobile=${mobile}`
                }


            } catch (error) {
                setLoading(false)
                let message = {
                    text: 'خطا در ارتباط با سرور'
                }
                showError(message)
            }

        }
        setValidated(true);
    }

    const customSelectStyles = {
        option: (provided) => ({
            ...provided,
            fontSize: "14px", // Customize font size here
            padding: "10px",
            fontWeight: '400' // Optional: Adjust padding for a better look
        }),
        control: (provided) => ({
            ...provided,
            fontSize: "14px", // Change font size for the selected option box
            fontWeight: '400'
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: "14px", // Change font size for the currently selected value
            fontWeight: '400'
        }),
    };
    const CustomDropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.8527 9.64582C18.0484 9.84073 18.0489 10.1573 17.854 10.3529L12.389 15.8374C12.1741 16.0531 11.8248 16.0531 11.6098 15.8374L6.14484 10.3529C5.94993 10.1573 5.95049 9.84073 6.1461 9.64582C6.34171 9.4509 6.65829 9.45147 6.85321 9.64708L11.9994 14.8117L17.1456 9.64708C17.3406 9.45147 17.6571 9.4509 17.8527 9.64582Z" fill="#000" />
                </svg>

            </components.DropdownIndicator>
        );
    };
    const handleSelectChange = (selected) => {
        setSubjectId(selected ? selected.value : ""); // تنظیم مقدار `text` با انتخاب یا حذف مقدار
        setIsSubjectInvalid(!selected);
    };
    const optionsSubject = subject.map((text) => ({ value: text.id, label: text.title }));
    const handleSelectDepartmanChange = (selected) => {
        setDepartmentId(selected.value); // تنظیم مقدار `text` با انتخاب یا حذف مقدار
        setIsDepartmentInvalid(!selected); // اگر گزینه‌ای انتخاب نشود، خطا را فعال می‌کند

    };
    const optionsDepartman = department.map((text) => ({ value: text.id, label: text.title }));

    const subjectTitle = useMemo(() => {
        try {
            if (subjectId && subject) {
                return subject.find(item => item.id === subjectId).title;
            }
            else {
                return '';
            }
        } catch (error) {

        }
    }, [subjectId]);
    const departmanTitle = useMemo(() => {
        try {
            if (departmentId && department) {
                return department.find(item => item.id === departmentId).title;
            }
            else {
                return '';
            }
        } catch (error) {

        }
    }, [departmentId]);
    return (
        <div>
            <Toast ref={toast} />

            <Form noValidate validated={validated} onSubmit={(e) => createContact(e)}>
                <div className="text-sm font-bold mt-4 row gy-2">
                    {/* <div className="flex gap-2 align-items-end flex-mob-col"> */}
                    <Form.Group controlId="name" className="col-md-6 col-lg-6 col-12 mb-2">
                        <Form.Label>نام و نام خانوادگی<span className='text-[red]'> * </span></Form.Label>
                        <Form.Control required value={fullName} onChange={(e) => setFullName(e.target.value)} type="text" />
                        <Form.Control.Feedback type="invalid">
                            نام و نام خانوادگی را وارد کنید.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="contact" className="col-md-6 col-lg-6 col-12 mb-2">
                        <Form.Label>شماره تماس <span className='text-[red]'> * </span></Form.Label>

                        <Form.Control required value={mobile} onChange={(e) => setMobile(e.target.value)} type="text" />
                        <Form.Control.Feedback type="invalid">
                            شماره تماس را وارد کنید.
                        </Form.Control.Feedback>
                    </Form.Group>
                    {/* </div> */}


                    {/* <div className="flex gap-2 align-items-end flex-mob-col"> */}
                    <Form.Group controlId="subject" className="col-md-6 col-lg-6 col-12 mb-2">
                        <Form.Label>موضوع<span className='text-[red]'> * </span></Form.Label>
                        <div className='web'>
                            <Select
                                options={optionsSubject}
                                value={subjectId ? optionsSubject.find((option) => option.id === subjectId) : null}
                                onChange={handleSelectChange}
                                styles={customSelectStyles}
                                
                                placeholder=''
                                className={isSubjectInvalid ? 'is-invalid' : ''} // اضافه کردن کلاس برای نمایش خطا
                                components={{ DropdownIndicator: CustomDropdownIndicator }}
                            />
                            {isSubjectInvalid && (
                                <Form.Control.Feedback type="invalid">
                                    موضوع را انتخاب کنید.
                                </Form.Control.Feedback>
                            )}
                        </div>
                        <div className='mobile'>

                            <div className='input-icon '>
                                <Form.Control value={subjectTitle}
                                    placeholder=''
                                    required
                                    onClick={(e) => {
                                        e.preventDefault(); // جلوگیری از باز شدن لیست
                                        setVisibleSubject(true); // نمایش Sidebar
                                    }}
                                    readOnly />
                                <img src={ArrowDown} alt="" />
                            </div>
                            <Form.Control.Feedback type="invalid">
                                موضوع را انتخاب کنید.
                            </Form.Control.Feedback>
                        </div>
                        <Sidebar
                            header="موضوع"
                            visible={visibleSubject}
                            position="bottom"
                            onHide={() => setVisibleSubject(false)}
                        >
                            <div className="prepared-text-options">
                                {subject.map((item, index) => (
                                    <div
                                        key={index}
                                        className={`prepared-text-item ${subjectId === item.id ? 'selected' : ''}`}
                                        onClick={() => {
                                            setSubjectId(item.id);
                                            isMobile === true && setVisibleSubject(false); // Close sidebar on selection
                                        }}
                                        style={{
                                            padding: '10px',
                                            borderBottom: '1px solid #eee',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        {item.title}
                                    </div>
                                ))}
                            </div>
                        </Sidebar>

                    </Form.Group>
                    <Form.Group controlId="department" className="col-md-6 col-lg-6 col-12 mb-2">
                        <Form.Label>دپارتمان<span className='text-[red]'> * </span></Form.Label>
                        <div className='web'>
                            <Select
                                options={optionsDepartman}
                                value={departmentId ? optionsDepartman.find((option) => option.label === departmentId.label) : null}
                                onChange={handleSelectDepartmanChange}
                                styles={customSelectStyles}
                                placeholder=''
                                
                                components={{ DropdownIndicator: CustomDropdownIndicator }}
                                className={isDepartmentInvalid ? 'is-invalid' : ''} // اضافه کردن کلاس برای نمایش خطا

                            />

                            {isDepartmentInvalid && (
                                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                    دپارتمان را انتخاب کنید.
                                </Form.Control.Feedback>
                            )}
                        </div>
                        <div className='mobile'>

                            <div className='input-icon '>
                                <Form.Control value={departmanTitle}
                                    placeholder=''
                                    onClick={(e) => {
                                        e.preventDefault(); // جلوگیری از باز شدن لیست
                                        setVisibleDepartman(true); // نمایش Sidebar
                                    }}
                                    readOnly />
                                <img src={ArrowDown} alt="" />
                            </div>
                        </div>
                        <Sidebar
                            header="دپارتمان"
                            visible={visibleDepartman}
                            position="bottom"
                            onHide={() => setVisibleDepartman(false)}
                        >
                            <div className="prepared-text-options">
                                {department.map((item, index) => (
                                    <div
                                        key={index}
                                        className={`prepared-text-item ${departmentId === item.id ? 'selected' : ''}`}
                                        onClick={() => {
                                            setDepartmentId(item.id);
                                            isMobile === true && setVisibleDepartman(false); // Close sidebar on selection
                                        }}
                                        style={{
                                            padding: '10px',
                                            borderBottom: '1px solid #eee',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        {item.title}
                                    </div>
                                ))}
                            </div>
                        </Sidebar>
                    </Form.Group>
                    {/* </div> */}

                    {/* <div className="flex gap-2 align-items-end"> */}
                    <Form.Group controlId="message" className=" col-12 mb-2">
                        <Form.Label>متن پیام<span className='text-[red]'> * </span></Form.Label>

                        <Form.Control required value={message} onChange={(e) => setMessage(e.target.value)} type="text" as="textarea" rows={1} />
                        <Form.Control.Feedback type="invalid">
                            متن پیام را وارد کنید.
                        </Form.Control.Feedback>
                    </Form.Group>
                    {/* </div> */}
                </div>
                <button disabled={loading} className="btn btn-primary w-1/3 max-sm:!w-full d-flex align-items-center gap-2 mt-2" type="submit" style={{ float: 'inline-end' }}>ثبت {loading && <Loader />}</button>
            </Form>
        </div>
    );
}

export default ContactUs;
